import './CommissionStructure.css';
import starIcon from '../assets/Star 1.svg';

const CommissionStructure = () => {
  return (
    <div className="commission-structure">
      <h3 className="commission-structure__title">Commission Structure</h3>
      <p className="commission-structure__description">
        Supercharge your revenue with our generous commission structure; more players, more cash in your wallet.
      </p>
      <ul className="commission-structure__list">
        <li>
          <img src={starIcon} alt="" className="commission-structure__icon" />
          Up to 50% Revenue Share
        </li>
        <li>
          <img src={starIcon} alt="" className="commission-structure__icon" />
          Fair Commission Structure
        </li>
        <li>
          <img src={starIcon} alt="" className="commission-structure__icon" />
          Start Earning Today
        </li>
      </ul>
    </div>
  );
};

export default CommissionStructure;
